/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'file/tif': {
    width: 48,
    height: 48,
    viewBox: '0 0 48 48',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M9 3a2 2 0 00-2 2v38a2 2 0 002 2h30a2 2 0 002-2V16.414c0-.081-.005-.162-.015-.242a1.004 1.004 0 00-.41-.99 1.978 1.978 0 00-.16-.182L29 3.586a1.986 1.986 0 00-.182-.161.999.999 0 00-.99-.41A2 2 0 0027.586 3H9zm18 2H9v38h30V17H28a1 1 0 01-1-1V5zm10.586 10L29 6.414V15h8.586z" _fill="#0B2C62"/><path pid="1" _fill="#0B2C62" d="M8 22h26v15H8z"/><path pid="2" d="M14.356 25.454v1.1h1.958V33H17.7v-6.446h1.958v-1.1h-5.302zm7.54 0H20.51V33h1.386v-7.546zm6.592 0h-4.895V33h1.386v-3.388h2.86v-1.056h-2.86v-2.002h3.51v-1.1z" _fill="#fff"/>'
  }
})
